import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6f63574c")

_pushScopeId("data-v-6f63574c")
const _hoisted_1 = { class: "inline-flex items-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: [_ctx.classes, "flex items-start"]
  }, [
    _createVNode("label", _hoisted_1, [
      _createVNode("input", {
        type: "checkbox",
        checked: _ctx.isSelected,
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCheck && _ctx.toggleCheck(...args))),
        class: "form-checkbox h-4 w-4",
        disabled: _ctx.disabled
      }, null, 40, ["checked", "disabled"]),
      (_ctx.label || _ctx.optionCheckbox.label)
        ? (_openBlock(), _createBlock("span", {
            key: 0,
            class: "ml-2",
            style: { fontWeight: _ctx.labelBold ? 'bold' : 'normal' }
          }, _toDisplayString(_ctx.label || _ctx.optionCheckbox.label), 5))
        : _createCommentVNode("", true)
    ])
  ], 2))
})